import { render, staticRenderFns } from "./WoView.vue?vue&type=template&id=40f00064"
import script from "./WoView.vue?vue&type=script&lang=js"
export * from "./WoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports